import React, { Component } from "react";
import Info from "./Info";
import { connect } from "react-redux";
import * as _ from "lodash";
import tippy from "tippy.js";
import moment from "moment";
import doNotSellImg from "../../media/icons/DoNotSell.png";
import deleteInfoImg from "../../media/icons/DeleteMyInfo.png";
import accessInfoImg from "../../media/icons/AccessMyInfo.png";
import correctDataImg from "../../media/icons/CorrectData.png";
import * as rk from "../../localization/resourceKeys";
import i18n from "../../i18n";
import { withTranslation } from "react-i18next";
import {
  getPrivacyManagement,
  statusFormSuccess,
  getDocStoreReport,
  getVWGoADocument,
} from "../../redux/StatusForm/statusActions";
import { clearErrors } from "../../redux/Errors/actions";
import BannerNotification from "../../banner/bannerNotification";
import BottomLine from "../Footer/BottomLine";
import StatusCircle from "./statusCircle";
import "./statusForm.css";
import { Logger } from "../../Logger/logger";
import PropTypes from "prop-types";

class statusForm extends Component {
  constructor(props) {
    super(props);
    const { selectedRequest, country, stateSelector } = this.props;
    const isCanada = country?.toLowerCase() === "canada";
    const areProtectionServices =
      stateSelector?.brandAffiliation === i18n.t(rk.BRANDS_OPTION_VWD_APP_DER);

    if (!selectedRequest && !isCanada && !areProtectionServices) {
      window.location.replace("/");
    }
    this.state = {
      requestId: "",
    };

    this.tooltips = [];
  }

  componentDidMount() {
    this.props.clearErrors();
    const _this = this;
    window.addEventListener("popstate", (e) => {
      _this.props.history.push("/");
    });

    this.props.getPrivacyManagement(
      this.getobjPrivacyManagementDetails(),
      this.props,
      this.setStatusFormDetails
    );
  }

  // code added to load tooltip styles from Bronson when RequestType get the value
  componentDidUpdate(prevProps, prevState) {
    this.tooltips.forEach((tooltip) => tooltip.destroy());
    this.tooltips = [];

    const tooltips = document.querySelectorAll(".report-tooltip");
    this.tooltips = tippy(tooltips, {
      interactive: true,
      allowHTML: true,
    });
  }

  getReportsAvailableCount = () => {
    const docStoreData = this.props.docStoreData;
    const docNames = [];
    if (docStoreData !== undefined) {
      const documents = docStoreData.documents;
      documents.forEach((document) => {
        if (!docNames.includes(document.privacyDocumentType)) {
          docNames.push(document.privacyDocumentType);
        }
      });
    }
    return docNames;
  };

  getobjPrivacyManagementDetails = () => {
    const requestId =
      this.props?.requestId || this.props?.location?.state?.requestId;
    const confirmationNumber =
      this.props?.confirmationNumber ||
      this.props?.location?.state?.confirmationNumber;
    const pin = this.props?.pin || this.props?.location?.state?.pin;
    const isVWGoAConfirmationNumber = this.isVWGoAConfirmationNumber();
    const response = this.props?.location?.state?.response;
    const lastName = this.props?.location?.state?.payload?.lastName;
    const objPrivacyManagementDetails = {
      requestId,
      confirmationNumber,
      pin,
      ...(isVWGoAConfirmationNumber && {
        isVWGoAConfirmationNumber,
        response,
        lastName,
      }),
    };
    return objPrivacyManagementDetails;
  };

  renderSatusCircle(value) {
    if (value.toLowerCase() === "pending") {
      return <StatusCircle status="pending" />;
    } else if (value.toLowerCase() === "canceled") {
      return <StatusCircle status="canceled" />;
    } else if (value.toLowerCase() === "notfound") {
      return <StatusCircle status="canceled" />;
    } else {
      return <StatusCircle status="completed" />;
    }
  }

  getStatus(value) {
    if (value.toLowerCase() === "pending") {
      return i18n.t(rk.STATUS_FORM.PENDING);
    } else if (value.toLowerCase() === "canceled") {
      return i18n.t(rk.STATUS_FORM.CANCELED);
    } else if (value.toLowerCase() === "notfound") {
      return i18n.t(rk.STATUS_FORM.NOT_FOUND);
    } else {
      return i18n.t(rk.STATUS_FORM.COMPLETED);
    }
  }

  setRequestTypeImage(requestTypeImage) {
    if (requestTypeImage) {
      if (requestTypeImage === "DO_NOT_SELL") {
        return doNotSellImg;
      } else if (requestTypeImage === "DELETE") {
        return deleteInfoImg;
      } else if (
        requestTypeImage === "TIER1_RPT" ||
        requestTypeImage === "TIER2_RPT"
      ) {
        return accessInfoImg;
      } else if (requestTypeImage === "Do_Not_Use") {
        return doNotSellImg;
      } else if (
        requestTypeImage === "CORRECT_DATA" ||
        requestTypeImage === "RIGHT_TO_DATA_CORRECTION"
      ) {
        return correctDataImg;
      } else if (requestTypeImage === "Right_to_Limit_Data") {
        return doNotSellImg;
      }
    }
  }

  setRequestTypeText(requestType, brand) {
    const { downGradeDate, vwgoaDowngradeInd, t } = this.props;
    if (requestType === "DO_NOT_SELL" && brand === "vwgoa") {
      return (
        <div className="u-mb-small">
          <p className="u-mb-none">{t(rk.STATUS_FORM.DO_NOT_SELL_REQUEST)}</p>
          <p className="date-text u-mb-none">
            {t(rk.STATUS_FORM.BRAND_REQUEST)}
          </p>
        </div>
      );
    } else if (requestType === "DO_NOT_SELL" && brand === "vci") {
      return (
        <div className="u-mb-small">
          <p className="u-mb-none">{t(rk.STATUS_FORM.DO_NOT_SELL_REQUEST)}</p>
          <p className="date-text u-mb-none">{t(rk.STATUS_FORM.VCI_REQUEST)}</p>
        </div>
      );
    } else if (requestType === "DELETE" && brand === "vwgoa") {
      return (
        <div className="u-mb-small">
          <p className="u-mb-none">{t(rk.STATUS_FORM.DELETE_INFO_REQUEST)}</p>
          <p className="date-text u-mb-none">
            {t(rk.STATUS_FORM.BRAND_REQUEST)}
          </p>
        </div>
      );
    } else if (requestType === "DELETE" && brand === "vci") {
      return (
        <div className="u-mb-small">
          <p className="u-mb-none">{t(rk.STATUS_FORM.DELETE_INFO_REQUEST)}</p>
          <p className="date-text u-mb-none">{t(rk.STATUS_FORM.VCI_REQUEST)}</p>
        </div>
      );
    } else if (requestType === "Do_Not_Use" && brand === "vwgoa") {
      return (
        <div className="u-mb-small">
          <p className="u-mb-none">{t(rk.REQUEST_SELECTOR.DO_NOT_USE_INFO)}</p>
          <p className="date-text u-mb-none">
            {t(rk.STATUS_FORM.BRAND_REQUEST)}
          </p>
        </div>
      );
    } else if (requestType === "Do_Not_Use" && brand === "vci") {
      return (
        <div className="u-mb-small">
          <p className="u-mb-none">{t(rk.REQUEST_SELECTOR.DO_NOT_USE_INFO)}</p>
          <p className="date-text u-mb-none">{t(rk.STATUS_FORM.VCI_REQUEST)}</p>
        </div>
      );
    } else if (requestType === "CORRECT_DATA" && brand === "vwgoa") {
      return (
        <div className="u-mb-small">
          <p className="u-mb-none">{t(rk.REQUEST_SELECTOR.CORRECT_MY_DATA)}</p>
          <p className="date-text u-mb-none">
            {t(rk.STATUS_FORM.BRAND_REQUEST)}
          </p>
        </div>
      );
    } else if (requestType === "CORRECT_DATA" && brand === "vci") {
      return (
        <div className="u-mb-small">
          <p className="u-mb-none">{t(rk.REQUEST_SELECTOR.CORRECT_MY_DATA)}</p>
          <p className="date-text u-mb-none">{t(rk.STATUS_FORM.VCI_REQUEST)}</p>
        </div>
      );
    } else if (requestType === "Right_to_Limit_Data" && brand === "vwgoa") {
      return (
        <div className="u-mb-small">
          <p className="u-mb-none">{t(rk.REQUEST_SELECTOR.LIMIT_DATA)}</p>
          <p className="date-text u-mb-none">
            {t(rk.STATUS_FORM.BRAND_REQUEST)}
          </p>
        </div>
      );
    } else if (requestType === "Right_to_Limit_Data" && brand === "vci") {
      return (
        <div className="u-mb-small">
          <p className="u-mb-none">{t(rk.REQUEST_SELECTOR.LIMIT_DATA)}</p>
          <p className="date-text u-mb-none">{t(rk.STATUS_FORM.VCI_REQUEST)}</p>
        </div>
      );
    } else if (vwgoaDowngradeInd && brand === "vwgoa") {
      return t(rk.STATUS_FORM.BRAND_TIER1_REQUEST);
    } else if (downGradeDate && brand === "vci") {
      return t(rk.STATUS_FORM.VCI_TIER1_REQUEST);
    } else if (requestType === "TIER1_RPT" && brand === "vwgoa") {
      return t(rk.STATUS_FORM.BRAND_TIER1_REQUEST);
    } else if (requestType === "TIER2_RPT" && brand === "vwgoa") {
      return t(rk.STATUS_FORM.BRAND_TIER2_REQUEST);
    } else if (requestType === "TIER1_RPT" && brand === "vci") {
      return t(rk.STATUS_FORM.VCI_TIER1_REQUEST);
    } else if (requestType === "TIER2_RPT" && brand === "vci") {
      return t(rk.STATUS_FORM.VCI_TIER2_REQUEST);
    } else if (requestType === "DO_NOT_SELL") {
      return t(rk.STATUS_FORM.DO_NOT_SELL_REQUEST);
    } else if (requestType === "TIER1_RPT") {
      return t(rk.STATUS_FORM.TIER1_REQUEST);
    } else if (requestType === "TIER2_RPT") {
      return t(rk.STATUS_FORM.TIER2_REQUEST);
    } else if (requestType === "DELETE") {
      return t(rk.STATUS_FORM.DELETE_INFO_REQUEST);
    } else if (
      requestType === "CORRECT_DATA" ||
      requestType === "RIGHT_TO_DATA_CORRECTION"
    ) {
      return t(rk.REQUEST_SELECTOR.CORRECT_MY_DATA);
    }
  }

  setRequestCardContent(requestType, t) {
    const selectedFlow = this.props.stateSelector.selectedFlow;

    if (requestType === "DO_NOT_SELL") {
      return (
        <div>
          <p>{t(rk.REQUEST_SELECTOR.DO_NOT_SELL_INFO_CARD_BODY1)}</p>
          <p>{t(rk.REQUEST_SELECTOR.DO_NOT_SELL_INFO_CARD_BODY2)}</p>
        </div>
      );
    } else if (requestType === "DELETE") {
      return (
        <div>
          <p>{t(rk.REQUEST_SELECTOR.DELETE_INFO_CARD_BODY1)}</p>
        </div>
      );
    } else if (requestType === "TIER1_RPT" || requestType === "TIER2_RPT") {
      return selectedFlow === "check" ? (
        <div>
          <p>
            {requestType === "TIER1_RPT"
              ? t(rk.CHECK_STATUS.CATEGORIES_REPORT)
              : t(rk.CHECK_STATUS.SPECIFIC_PIECES_REPORT)}
          </p>
        </div>
      ) : (
        <div>
          <p>{t(rk.REQUEST_SELECTOR.ACCESS_INFO_CARD_BODY1)}</p>
          <p>{t(rk.REQUEST_SELECTOR.ACCESS_INFO_CARD_BODY2)}</p>
        </div>
      );
    } else if (
      requestType === "CORRECT_DATA" ||
      requestType === "RIGHT_TO_DATA_CORRECTION"
    ) {
      return (
        <div>
          <p>{t(rk.REQUEST_SELECTOR.DATA_CORRECTION_CARD_BODY)}</p>
        </div>
      );
    }
  }

  setStatusFormDetails(values) {
    this.props.statusFormSuccess(values);
  }

  hasReports() {
    if (
      this.props?.docStoreData?.documents.length > 0 ||
      (this.props.combinedStatus?.toLowerCase() === "completed" &&
        this.isVWGoAConfirmationNumber())
    ) {
      return true;
    }
    return false;
  }

  isReportsRequest() {
    if (
      this.props.requestType === "TIER1_RPT" ||
      this.props.requestType === "TIER2_RPT"
    ) {
      return true;
    }
    return false;
  }
  getFileExt(documentName) {
    let ext = documentName.split(".");
    let type = ext[ext.length - 1];
    return type;
  }

  lookUpFile(privacyDocumentType, fileType) {
    const { docStoreData = { documents: [] } } = this.props;
    return docStoreData.documents.find(
      (document) =>
        document.privacyDocumentType === privacyDocumentType &&
        this.getFileExt(document.documentName) === fileType
    );
  }

  /**
   * fuction for rendering the request type and status of request.
   * @function
   * @param {string} image - path of the image.
   * @param {string} value - associated with field value.
   */
  renderColumnData = (image, value, type) => {
    const { t } = this.props;
    const isQuebec = this.props.country?.toLowerCase() === "canada";
    const requestType = this.props.requestType;
    return (
      <div className="content-type input-container">
        {type === "requestType" ? (
          <div className="u-mv-xsmall status-holder">
            <img
              className="u-mr-small"
              src={image ? image : ""}
              alt="Request Report Icon"
              width="50px"
            ></img>
            <div className="u-ml-xsmall">
              {value && <p className="u-m-none u-pr-small">{value}</p>}
              {this.props.requestDate && this.isReportsRequest() && (
                <p className="date-text u-m-none">
                  {t(rk.STATUS_FORM.DATE_REQUESTED_MUTED_TEXT)}
                  {`${moment(this.props.requestDate).format("MM/DD/YYYY")}`}
                </p>
              )}
            </div>
          </div>
        ) : null}

        {type === "dateRequested" ? (
          <div>
            <div className="status-mobile-titles">
              <div>
                {t(rk.STATUS_FORM.DATE_REQUESTED_MUTED_TEXT)}
                {`${value}`}
              </div>
            </div>
            <p className="u-mb-none status-desktop-titles">{`${value}`}</p>
          </div>
        ) : null}
        {type === "requestStatus" && (
          <div className="report-status">
            {value && (
              <div className="u-mr-xxsmall">
                {this.renderSatusCircle(value)}
              </div>
            )}
            {value && (
              <p className="label-text u-m-none u-ml-xsmall">
                {this.getStatus(value)}
              </p>
            )}
          </div>
        )}
        {type === "downloadColumn" && this.isReportsRequest() ? (
          <>
            {!this.hasReports() ? (
              <div>
                {this.props.combinedStatus?.toLowerCase() === "canceled" && (
                  <p className="pending-text u-11/12">
                    {t(rk.STATUS_FORM.CANCELED_TEXT)}
                  </p>
                )}
                {this.props.combinedStatus?.toLowerCase() === "notfound" && (
                  <p className="pending-text u-11/12">
                    {t(rk.STATUS_FORM.NOT_FOUND_TEXT)}
                  </p>
                )}
                {this.props.combinedStatus?.toLowerCase() === "pending" && (
                  <p className="pending-text u-11/12">
                    {t(rk.STATUS_FORM.PENDING_TEXT)}
                  </p>
                )}
              </div>
            ) : (
              <>
                {!isQuebec && (
                  <div className="o-layout__item u-1/1@xs u-1/1@s u-1/1@m u-1/2 u-m-none u-p-none u-pr-small u-mv-small select-container">
                    <div className="c-input c-input--select">
                      <select
                        className="c-input__input"
                        id={`fileType${value}`}
                        data-testid={`fileType${value}`}
                        aria-label="File Type"
                        onChange={(e) => {
                          const fileType = document.getElementById(
                            `fileType${value}`
                          ).value;
                          if (
                            fileType ===
                              `${t(rk.STATUS_FORM.SELECT_DEFAULT)}` ||
                            fileType === ""
                          ) {
                            document
                              .getElementById(`download-btn${value}`)
                              .setAttribute("disabled", true);
                          } else {
                            document
                              .getElementById(`download-btn${value}`)
                              .removeAttribute("disabled");
                            document.getElementById(
                              `download-btn${value}`
                            ).onclick = async () => {
                              await this.props.clearErrors();
                              if (this.isVWGoAConfirmationNumber()) {
                                this.props.getVWGoADocument(
                                  {
                                    reportType: `${fileType}`.toUpperCase(),
                                    ...this.getobjPrivacyManagementDetails(),
                                  },
                                  (data) => {
                                    this.convertDocument(
                                      `PRIVACY-REPORT-${value}.${fileType}`,
                                      data,
                                      `application/${fileType}`
                                    );
                                  }
                                );
                              } else {
                                const document =
                                  this.props.docStoreData.documents.find(
                                    (document) =>
                                      document.privacyDocumentType === value &&
                                      this.getFileExt(document.documentName) ===
                                        fileType
                                  );
                                const displayDocName = this.setReportName(
                                  this.props.requestType,
                                  document.privacyDocumentType,
                                  fileType,
                                  document.documentName
                                );
                                const data = document.documentData;
                                this.convertDocument(
                                  displayDocName,
                                  data,
                                  `application/${fileType}`
                                );
                              }
                            };
                          }
                        }}
                      >
                        <option value="" defaultValue>
                          {t(rk.STATUS_FORM.SELECT_DEFAULT)}
                        </option>
                        {(this.lookUpFile(value, "pdf") ||
                          this.isVWGoAConfirmationNumber()) && (
                          <option value="pdf">
                            {t(rk.STATUS_FORM.SELECT_PDF)}
                          </option>
                        )}
                        {(this.lookUpFile(value, "json") ||
                          (this.isVWGoAConfirmationNumber() &&
                            requestType === "TIER2_RPT")) && (
                          <option value="json">
                            {t(rk.STATUS_FORM.SELECT_JSON)}
                          </option>
                        )}
                        {this.lookUpFile(value, "zip") && (
                          <option value="zip">
                            {t(rk.STATUS_FORM.SELECT_ZIP)}
                          </option>
                        )}
                      </select>
                    </div>
                  </div>
                )}
                <div className="o-layout__item u-1/1@s u-p-none u-m-none u-pr-small button-container">
                  <button
                    className="c-btn"
                    id={`download-btn${value}`}
                    data-testid={`download-btn${value}`}
                    onClick={async () => {
                      await this.props.clearErrors();
                      const document = this.props.docStoreData.documents.find(
                        (document) =>
                          document.privacyDocumentType === value &&
                          this.getFileExt(document.documentName) === "pdf"
                      );
                      const displayDocName = this.setReportName(
                        this.props.requestType,
                        document.privacyDocumentType,
                        "pdf",
                        document.documentName
                      );
                      const data = document.documentData;
                      this.convertDocument(
                        displayDocName,
                        data,
                        `application/pdf`
                      );
                    }}
                    disabled={!isQuebec}
                  >
                    <span className="c-btn__text">{t(rk.BUTTON.DOWNLOAD)}</span>
                  </button>
                </div>
              </>
            )}
          </>
        ) : null}
      </div>
    );
  };

  setReportName(requestType, privacyDocumentType, fileType, documentName) {
    if (fileType === "zip") {
      return documentName;
    } else {
      if (requestType === "TIER1_RPT" && privacyDocumentType === 0) {
        return `${i18n.t(rk.STATUS_FORM.VCI_TIER1_REQUEST)}`;
      } else if (requestType === "TIER1_RPT" && privacyDocumentType === 1) {
        return `${i18n.t(rk.STATUS_FORM.BRAND_TIER1_REQUEST)}`;
      } else if (requestType === "TIER2_RPT" && privacyDocumentType === 0) {
        return `${i18n.t(rk.STATUS_FORM.VCI_TIER2_REQUEST)}`;
      } else if (requestType === "TIER2_RPT" && privacyDocumentType === 1) {
        return `${i18n.t(rk.STATUS_FORM.BRAND_TIER2_REQUEST)}`;
      }
    }
  }

  base64ToArrayBuffer(base64) {
    let binaryString = window.atob(base64);
    let binaryLen = binaryString.length;
    let bytes = new Uint8Array(binaryLen);
    for (let i = 0; i < binaryLen; i++) {
      let ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
    }
    return bytes;
  }

  convertDocument(reportName, base64, type) {
    let byteArray = this.base64ToArrayBuffer(base64);
    let blob = new Blob([byteArray], { type });
    let link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    let fileName = reportName;
    link.download = fileName;
    link.click();
    Logger.info(
      `User successfully downloaded report of type ${type}`,
      "Location ==> /status",
      "Report Downloaded"
    );
  }

  reportDowngrade() {
    let downGradeResult = false;
    const { downGradeDate, vwgoaDowngradeInd, combinedStatus, requestType } =
      this.props;
    if (combinedStatus) {
      if (
        combinedStatus.toLowerCase() === "completed" &&
        (downGradeDate || vwgoaDowngradeInd) &&
        (requestType === "TIER1_RPT" || requestType === "TIER2_RPT")
      ) {
        downGradeResult = false;
      }
    }
    return downGradeResult;
  }

  isVWGoAConfirmationNumber() {
    return (
      this.props?.isVWGoAConfirmationNumber ||
      this.props?.location?.state?.isVWGoAConfirmationNumber
    );
  }

  render() {
    const { t } = this.props;
    let dataSet = [];
    const { docStoreData = { documents: [] } } = this.props;
    const isQuebec = this.props.country?.toLowerCase() === "canada";
    const isProtectionServices =
      this.props?.stateSelector?.brandAffiliation ===
      i18n.t(rk.BRANDS_OPTION_VWD_APP_DER);
    const isVWGoAConfirmationNumber = this.isVWGoAConfirmationNumber();

    if (docStoreData.documents.length > 0) {
      // add two objects - one for vwgoa and one for VCI
      // privacyDocType = 1 for VWGOA
      // privacyDocType = 0 for VCI
      if (!isQuebec && !isProtectionServices) {
        dataSet.push(
          {
            type: "requestType",
            headerTitle: t(rk.STATUS_FORM.TYPE_HEADER),
            image: accessInfoImg,
            value: this.setReportName(this.props.requestType, 1),
          },
          {
            type: "dateRequested",
            headerTitle: t(rk.STATUS_FORM.DATE_REQUESTED_HEADER),
            image: "",
            value: moment(this.props.requestDate).format("MM/DD/YYYY"),
          },
          {
            type: "requestStatus",
            headerTitle: t(rk.STATUS_FORM.STATUS_HEADER),
            image: "green",
            value: "Completed",
          },
          {
            type: "downloadColumn",
            headerTitle: "",
            image: "",
            value: 1,
          }
        );
      }
      if (!isVWGoAConfirmationNumber) {
        dataSet.push(
          {
            type: "requestType",
            headerTitle: t(rk.STATUS_FORM.TYPE_HEADER),
            image: accessInfoImg,
            value: this.setReportName(this.props.requestType, 0),
          },
          {
            type: "dateRequested",
            headerTitle: t(rk.STATUS_FORM.DATE_REQUESTED_HEADER),
            image: "",
            value: moment(this.props.requestDate).format("MM/DD/YYYY"),
          },
          {
            type: "requestStatus",
            headerTitle: t(rk.STATUS_FORM.STATUS_HEADER),
            image: "green",
            value: "Completed",
          },
          {
            type: "downloadColumn",
            headerTitle: "",
            image: "",
            value: 0,
          }
        );
      }
    } else {
      if (!isQuebec && !isProtectionServices) {
        dataSet.push(
          {
            type: "requestType",
            headerTitle: t(rk.STATUS_FORM.TYPE_HEADER),
            image: this.setRequestTypeImage(this.props.requestType),
            value: this.setRequestTypeText(this.props.requestType, "vwgoa"),
          },
          {
            type: "dateRequested",
            headerTitle: t(rk.STATUS_FORM.DATE_REQUESTED_HEADER),
            image: "",
            value: moment(this.props.requestDate).format("MM/DD/YYYY"),
          },
          {
            type: "requestStatus",
            headerTitle: t(rk.STATUS_FORM.STATUS_HEADER),
            value: this.props.combinedStatus,
          },
          {
            type: "downloadColumn",
            headerTitle: "",
            image: "",
            value: this.props.requestType,
            privacyDocumentType: this.setRequestTypeText(
              this.props.requestType,
              "vwgoa"
            ),
          }
        );
      }
      if (!isVWGoAConfirmationNumber) {
        dataSet.push(
          {
            type: "requestType",
            headerTitle: t(rk.STATUS_FORM.TYPE_HEADER),
            image: this.setRequestTypeImage(this.props.requestType),
            value: this.setRequestTypeText(this.props.requestType, "vci"),
          },
          {
            type: "dateRequested",
            headerTitle: t(rk.STATUS_FORM.DATE_REQUESTED_HEADER),
            image: "",
            value: moment(this.props.requestDate).format("MM/DD/YYYY"),
          },
          {
            type: "requestStatus",
            headerTitle: t(rk.STATUS_FORM.STATUS_HEADER),
            value: this.props.combinedStatus,
          },
          {
            type: "downloadColumn",
            headerTitle: "",
            image: "",
            value: this.props.requestType,
            privacyDocumentType: this.setRequestTypeText(
              this.props.requestType,
              "vci"
            ),
          }
        );
      }
    }

    let newDataSet = [];
    let objDataSet = null;
    dataSet.forEach((obj) => {
      if (obj.type === "requestType") {
        objDataSet = {};
      }
      objDataSet[obj.type] = obj;
      if (obj.type === "downloadColumn") {
        newDataSet.push(objDataSet);
      }
    });

    return this.props.requestType ? (
      <React.Fragment>
        {!_.isEmpty(this.props.networkError) && (
          <>
            {this.props.networkError.error === 404 ? (
              <BannerNotification notificationStyle="error">
                {t(rk.ERROR_DOCUMENT_NOT_FOUND)}
              </BannerNotification>
            ) : (
              <BannerNotification notificationStyle="error">
                {t(rk.ERROR_API_FAIL)}
              </BannerNotification>
            )}
          </>
        )}
        {(this.props.requestType === "TIER1_RPT" ||
          this.props.requestType === "TIER2_RPT") &&
          this.props.combinedStatus?.toLowerCase() === "pending" && (
            <div className="pending-header-text u-mb">
              {t(rk.STATUS_FORM.PENDING_MUTED_TEXT)}
            </div>
          )}
        {this.isReportsRequest() ? (
          <div className="o-layout u-m-none sfu-ph-small@>766px">
            <div className="status-holder">
              <div className="o-layout__item u-5/12">
                <div className="header-content u-mb-small">
                  {t(rk.STATUS_FORM.TYPE_HEADER)}
                </div>
              </div>

              <div className="o-layout__item u-2/12 sfu-3/12@<1024px">
                <div className="header-content u-mb-small">
                  {t(rk.STATUS_FORM.STATUS_HEADER)}
                </div>
              </div>

              <div className="o-layout__item u-4/12">
                <div className="header-content u-mb-small">
                  <span>
                    {t(rk.STATUS_FORM.DOWNLOAD_HEADER)}
                    <button
                      id="button-tooltip"
                      className="report-tooltip js-tooltip c-tooltip tooltip-icon u-mh-xsmall"
                      data-tippy-content={t(rk.STATUS_FORM.TOOLTIP_TEXT)}
                    >
                      i
                    </button>
                  </span>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="o-layout u-m-none sfu-ph-small@>766px">
            <div className="status-holder">
              <div className="o-layout__item u-5/12">
                <div className="header-content u-mb-small">
                  {t(rk.STATUS_FORM.TYPE_HEADER)}
                </div>
              </div>
              <div className="o-layout__item u-2/12 sfu-3/12@<1024px">
                <div className="header-content u-mb-small">
                  {t(rk.STATUS_FORM.DATE_REQUESTED_HEADER)}
                </div>
              </div>
              <div className="o-layout__item u-4/12">
                <div className="header-content u-mb-small">
                  {t(rk.STATUS_FORM.STATUS_HEADER)}
                </div>
              </div>
            </div>
          </div>
        )}
        {newDataSet.map((item, index) => (
          <div className="o-layout u-m-none" key={index}>
            <div className="u-bg-alternative u-mb-small u-pv-small sfu-ph-small@>766px status-holder">
              <div className="u-pl u-p-none status-mobile-titles">
                <div className="">{t(rk.STATUS_FORM.TYPE_HEADER)}</div>
              </div>
              <div className="o-layout__item u-5/12 sfu-1/1@<767px">
                {this.renderColumnData(
                  item.requestType.image,
                  item.requestType.value,
                  item.requestType.type
                )}
              </div>

              {!this.isReportsRequest() && (
                <div className="o-layout__item u-2/12 sfu-3/12@<1024px">
                  {this.renderColumnData(
                    item.requestType.image,
                    item.dateRequested.value,
                    item.dateRequested.type
                  )}
                </div>
              )}

              <div className="u-pl status-mobile-titles">
                <div className="">{t(rk.STATUS_FORM.STATUS_HEADER)}</div>
              </div>

              <div className="o-layout__item u-2/12 sfu-3/12@<1024px">
                {this.renderColumnData(
                  item.requestStatus.image,
                  item.requestStatus.value,
                  item.requestStatus.type
                )}
              </div>

              {this.isReportsRequest() && (
                <>
                  <div className="u-pl status-mobile-titles">
                    <span>
                      {t(rk.STATUS_FORM.DOWNLOAD_HEADER)}
                      <button
                        id={`button-tooltip-${index}`}
                        className="report-tooltip js-tooltip c-tooltip tooltip-icon u-mh-xsmall"
                        data-tippy-content={t(rk.STATUS_FORM.TOOLTIP_TEXT)}
                      >
                        i
                      </button>
                    </span>
                  </div>
                  <div className="o-layout__item u-4/12 sfu-1/1@<767px">
                    {this.renderColumnData(
                      "",
                      item.downloadColumn.value,
                      item.downloadColumn.type
                    )}
                  </div>
                </>
              )}
            </div>
          </div>
        ))}
        {this.reportDowngrade() ? (
          <React.Fragment>
            <div className="o-layout u-m-none">
              <div className="o-layout u-m-none">
                <Info
                  className="u-mt"
                  headerTitle={this.setRequestTypeText("TIER2_RPT")}
                  content={this.setRequestCardContent(
                    this.props.requestType,
                    t
                  )}
                />
              </div>
            </div>
            <div className="o-layout u-m-none">
              <div className="o-layout u-m-none">
                <Info
                  className="u-mt"
                  headerTitle={this.setRequestTypeText("TIER1_RPT")}
                  content={this.setRequestCardContent(
                    this.props.requestType,
                    t
                  )}
                />
              </div>
            </div>
          </React.Fragment>
        ) : (
          <div className="o-layout u-m-none">
            <div className="o-layout u-m-none">
              <Info
                className="u-mt"
                headerTitle={this.setRequestTypeText(this.props.requestType)}
                content={this.setRequestCardContent(this.props.requestType, t)}
              />
            </div>
          </div>
        )}
        <div className="request-footer-wrapper">
          <div id="request-footer-content" className="request-footer-content-2">
            <BottomLine />
          </div>
        </div>
      </React.Fragment>
    ) : (
      <>
        {!_.isEmpty(this.props.networkError) && (
          <BannerNotification notificationStyle="error">
            {t(rk.ERROR_API_FAIL)}
          </BannerNotification>
        )}
      </>
    );
  }
}

statusForm.propTypes = {
  country: {
    toLowerCase: PropTypes.func,
  },
  t: PropTypes.func,
  requestType: PropTypes.string,
  stateSelector: {
    brandAffiliation: PropTypes.string,
    selectedFlow: PropTypes.string,
  },
  selectedRequest: PropTypes.object,
  clearErrors: PropTypes.func,
  getPrivacyManagement: PropTypes.func,
  docStoreData: {
    documents: PropTypes.array,
  },
  requestId: PropTypes.string,
  location: {
    state: {
      requestId: PropTypes.string,
      confirmationNumber: PropTypes.string,
      pin: PropTypes.string,
    },
  },
  confirmationNumber: PropTypes.string,
  pin: PropTypes.string,
  requestDate: PropTypes.string,
  combinedStatus: PropTypes.string,
  vwgoaDowngradeInd: PropTypes.string,
  downGradeDate: PropTypes.string,
  networkError: PropTypes.object,
  getDocStoreReport: PropTypes.func,
  statusFormSuccess: PropTypes.func,
};

const mapStateToProps = (state) => ({
  country: state.initialReducer.country,
  requestId: state.verificationReducer.requestId,
  confirmationNumber: state.verificationReducer.confirmationNumber,
  pin: state.verificationReducer.pin,
  selectedRequest: state.requestSelector.selectedRequest,
  requestType: state.statusFormReducer.requestType,
  requestDate: state.statusFormReducer.requestDate,
  combinedStatus: state.statusFormReducer.combinedStatus,
  docStoreData: state.statusFormReducer.docStoreData,
  downGradeDate: state.statusFormReducer.downGradeDate,
  vwgoaDowngradeInd: state.statusFormReducer.vwgoaDowngradeInd,
  networkError: state.networkError,
  stateSelector: state.stateSelector,
  isVWGoAConfirmationNumber: state.isVWGoAConfirmationNumber,
});

const mapDispatchToProps = (dispatch) => ({
  getPrivacyManagement: (action, modalProps, setStatusFormDetails) =>
    dispatch(getPrivacyManagement(action, modalProps, setStatusFormDetails)),
  statusFormSuccess: (action) => dispatch(statusFormSuccess(action)),
  getDocStoreReport: (action, props) =>
    dispatch(getDocStoreReport(action, props)),
  getVWGoADocument: (action, convertDocument) =>
    dispatch(getVWGoADocument(action, convertDocument)),
  clearErrors: () => dispatch(clearErrors()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(statusForm));
